import jsPDF from 'jspdf';
import 'jspdf-autotable';
import config from "../common/Config";
import { axiosFetchProformaInvoice } from '../../utils/proformaInvoiceApi';

const generateUniqueFilename = (baseName, extension) => {
  const timestamp = new Date().toISOString().replace(/[-:.]/g, "");
  return `${baseName}_${timestamp}.${extension}`;
};

const generateOrderSummaryPDF = async (orderId) => {
  const accessToken = localStorage.getItem('accessToken');
  const token = localStorage.getItem('token');
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0');

    return `${day}-${month}-${year}`;  
  };

  try {
    const data = await axiosFetchProformaInvoice(orderId, token);

    if (!data.success || !data.details.orderDetails || data.details.orderDetails.length === 0) {
      console.error("No order details found in the response.");
      return;  
    }

    const orderDetails = data.details.orderDetails[0];  
    const shopDetails = data.details.shop_details;
    const deliveryDetails = data.details.delivery_details;

    const bundleDiscounts = Array.isArray(data.details.bundle_discounts) ? data.details.bundle_discounts : [];
    let promoDiscount = 0;
    let promoVat = 0;
    bundleDiscounts.forEach((bundle) => {
      const directPromoDiscount = parseFloat(bundle.total_discount ?? 0) || 0;
      const buyDiscount = parseFloat(bundle.buy_total_discount ?? 0) || 0;
      const getDiscount = parseFloat(bundle.get_total_discount ?? 0) || 0;
      promoDiscount += directPromoDiscount > 0 ? directPromoDiscount : (buyDiscount + getDiscount);
      promoVat += (parseFloat(bundle.buy_discount_vat ?? 0) || 0) + (parseFloat(bundle.get_discount_vat ?? 0) || 0);
    });
    
    const box_qty = data.details.product_details
    .filter(item => item.quantity != '0.00' && item.quantity != null && item.order_type === 'box')
    .reduce((sum, item) => sum + (parseFloat(item.quantity)), 0);

    const piece_qty = data.details.product_details
    .filter(item => item.quantity != '0.00' && item.quantity != null && item.order_type === 'piece')
    .reduce((sum, item) => sum + (parseFloat(item.quantity)), 0);

    const totalstd = data.details.product_details
      .filter((item) => parseFloat(item.item_tax || 0) !== 0)
      .reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0);

    const totalzeroGoods = data.details.product_details
      .filter((item) => parseFloat(item.item_tax || 0) === 0)
      .reduce((sum, item) => sum + parseFloat(item.subtotal || 0), 0);

    const orderDiscount1 = parseFloat(data.details.orderDetails[0].order_discount1) || 0;
    const over_all_discount = parseFloat(data.details.orderDetails[0].over_all_discount) || 0;
    const over_all_amount = parseFloat(data.details.orderDetails[0].over_all_amount) || 0;

    const totalVAT = data.details.product_details.reduce(
      (sum, item) => sum + parseFloat(item.item_tax || 0),
      0,
    );

    const itemTotal = totalstd + totalzeroGoods;

    const backendTotal = parseFloat(orderDetails.grand_total || 0);
    const totalAmount =
      backendTotal > 0
        ? backendTotal
        : itemTotal + totalVAT - over_all_amount - orderDiscount1 - (promoDiscount + promoVat);


    const doc = new jsPDF('portrait'); // Set to portrait orientation
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 8;  // Set margin to 10px
    let y = margin;
    const firstColumnWidth = pageWidth * 0.42;  // 30% of the page width
    const secondColumnWidth = pageWidth * 0.57; 
    const H2firstColumnWidth = pageWidth * 0.40; 
    const H2secondColumnWidth = pageWidth * 0.25; 
    const H2thirdColumnWidth = pageWidth * 0.25;
    // Add the logo image to the header (make sure the image path is correct)
    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`; // Path to the logo image
    const logoWidth = 40; // Width of the logo in the PDF (adjust as needed)
    const logoHeight = 23; // Height of the logo (adjust as needed)
    doc.addImage(logoUrl, 'PNG', margin, y, logoWidth, logoHeight); // Adds the logo at the top-left corner
    y += logoHeight + 5; // Adjust y position after adding the logo

    // Now create the other sections of the header
    const headerSections2 = [
      [
        // Add shop details (below logo)
        ],
      [
        { text: `${shopDetails.shop_name}`, size: 13, bold: true },
        { text: `${shopDetails.address}`, size: 8, bold: false },
        { text: `Phone No : ${shopDetails.phone} | Email : ${shopDetails.email}`, size: 8, bold: false },
        { text: `Website : ${shopDetails.website}`, size: 8, bold: false },
        { text: `Company No : ${shopDetails.company_reg_no} | VAT No : ${shopDetails.vat_no ? shopDetails.vat_no : ''}`, size: 8, bold: false },
        { text: `AWRS No : XYAW000001066654`, size: 8, bold: false },
        { text: `TOBACCO TRACE ID : QCUKTVQ42QRQB`, size: 8, bold: false },
      ],


      ];

    const headerSections3 = [
      [

        { text: `${orderDetails.company}`, size: 11, bold: true },
         { text: ``, size: 8, bold: false },
        {
          text: `${orderDetails.address.split(' ').slice(0, Math.ceil(orderDetails.address.split(' ').length / 2)).join(' ')}\n${orderDetails.address.split(' ').slice(Math.ceil(orderDetails.address.split(' ').length / 2)).join(' ')}`,
          size: 8,
          bold: false
          
        }, { text: ``, size: 8, bold: false },
        { text: `${orderDetails.city} ,${orderDetails.postal_code}`, size: 8, bold: false },
        { text: `Phone No : ${orderDetails.phone}`, size: 8, bold: false },
        { text: `Email Id : ${orderDetails.email}`, size: 8, bold: false },
        ],
      [
        { text: ``, size: 8, bold: false },
        { text: `Invoice No : ${orderDetails.reference_no}`, size: 8, bold: false },
        { text: `Order Date: ${orderDetails.date}`, size: 8, bold: false },
        { text: `Account No: ${orderDetails.account_no}`, size: 8, bold: false },
        ],
      [
        { text: `Bank Details`, size: 8, bold: true },
        { text: `${shopDetails.shop_name}`, size: 8, bold: true },
       
        { text: `A/C No : ${shopDetails.bank_ac}`, size: 8, bold: false},
        { text: `Sort Code: ${shopDetails.sort_code}`, size: 8, bold: false},
         { text: ``, size: 8, bold: false },
        ],
      ];

    const sectionWidth = (pageWidth - margin * 2) / 2; // Adjust for margins

    // Render header sections
    y = 12;
  const renderSections = (sections) => {
  sections.forEach((section, index) => {
    let colStartX;
    if (index % 3 === 0) {
      colStartX = margin;
    } else if (index % 3 === 1) {
      colStartX = margin + firstColumnWidth;
    } else {
      colStartX = margin + firstColumnWidth + secondColumnWidth;
    }
   // console.log('INDEX',index);
    // Special case: third section (index === 2), draw circle with "INVOICE"
    if (index == 1) {
      section.forEach((item, i) => {
        doc.setFontSize(item.size);
        doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
        doc.text(item.text, colStartX, y + i * 4); // Adjust spacing as needed
      });
     
      
      const margin = 10; // Define margin
  const ovalWidth = 24; // Width of the oval
  const ovalHeight = 10; // Height of the oval
  
  // Page width and height
  const pageWidth = doc.internal.pageSize.width;

  // Calculate the X and Y positions for the oval (to position it on the right side)
  const ovalX = pageWidth - margin - ovalWidth / 2; // Position the oval on the right side
  const ovalY = y + 10 + ovalHeight / 2; // Position the oval just below the rendered section
  
  // Draw the oval (ellipse)
  doc.setLineWidth(0.5);
  doc.ellipse(ovalX, ovalY, ovalWidth / 2, ovalHeight / 2, 'S'); // Draw ellipse border ('S' is for stroke)

  // Add "GB RP 008" text inside the oval
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  const textWidth = doc.getTextWidth('GB RP 008');
  doc.text('GB RP 008', ovalX - textWidth / 2, ovalY + 2); // Center the text inside the oval

     
    }

    if ((index + 1) % 3 === 0) {
      y += 20; // spacing between rows
    }
  });

  y += 25; // space after all sections
};

   const h2renderSections = (sections) => {
  let rowHeight = 0;
  let rowStartY = y;
  let columnHeights = [];

  sections.forEach((section, index) => {
    let colStartX;
    if (index % 3 === 0) {
      colStartX = margin;
    } else if (index % 3 === 1) {
      colStartX = margin + H2firstColumnWidth;
    } else {
      colStartX = margin + H2firstColumnWidth + H2secondColumnWidth;
    }

    let sectionHeight = 0;

    section.forEach((item, i) => {
      doc.setFontSize(item.size);
      doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');

      let maxWidth;
      if (index % 3 === 0) {
        maxWidth = H2firstColumnWidth - 5;
      } else if (index % 3 === 1) {
        maxWidth = H2secondColumnWidth - 5;
      } else {
        maxWidth = H2thirdColumnWidth - 5;
      }

      const textWidth = doc.getTextWidth(item.text);
      let lines = [];
      if (textWidth > maxWidth) {
        let words = item.text.split(' ');
        let line = '';

        words.forEach((word) => {
          const testLine = line + (line ? ' ' : '') + word;
          if (doc.getTextWidth(testLine) <= maxWidth) {
            line = testLine;
          } else {
            lines.push(line);
            line = word;
          }
        });
        lines.push(line);
      } else {
        lines.push(item.text);
      }

      lines.forEach((lineText, lineIndex) => {
        const lineHeight = 4;
        doc.text(lineText, colStartX + 5, y + 5 + i * lineHeight + lineIndex * lineHeight);
        sectionHeight = y + i + lineIndex - 5;
      });
    });

    columnHeights.push(sectionHeight);

    if ((index + 1) % 3 === 0) {
      rowHeight = Math.max(...columnHeights);
      columnHeights = [];

      // Borders have been removed from here — no `doc.rect()` called

      y += rowHeight + 0;
      rowStartY = y;
    }
  });

  y += -3;
};

    
    renderSections(headerSections2);
    h2renderSections(headerSections3);
    // Render table columns with customized widths
    const tableColumns = [
      { title: 'Product', dataKey: 'product', size: 6, bold: false },
      { title: 'Order T', dataKey: 'order_type', size: 6, bold: false },
      { title: 'Order Qty', dataKey: 'qty', size: 6, bold: false },
      { title: 'Unit Price', dataKey: 'unit_price', size: 6, bold: false },
      { title: 'Discount', dataKey: 'discount', size: 6, bold: false },
      { title: 'VAT', dataKey: 'vat', size: 6, bold: false },
      { title: 'Net Amount', dataKey: 'net_amount', size: 6, bold: false },
      ];

    // Calculate the table widths
    const totalWidth = pageWidth - 2 * margin;
    const productWidth = totalWidth * 0.45;  
    const orderTypeWidth = totalWidth * 0.06;  
    const qtyWidth = totalWidth * 0.06; 
    const unitPriceWidth = totalWidth * 0.12;  
    const discountWidth = totalWidth * 0.08;  
    const vatWidth = totalWidth * 0.11; 
    const netAmountWidth = totalWidth * 0.12; 



    /*const tableBody = data.details.product_details.map((item) => [
      item.product_code + ' - ' + item.product_name, 
      item.order_type,
      parseInt(item.order_qty), 
      '£ ' + parseFloat(item.unit_price).toFixed(2), 
      item.is_promoted, 
      '£ ' + parseFloat(item.item_tax).toFixed(2), 
      '£ ' + parseFloat(item.order_qty * item.unit_price).toFixed(2), 
    ]);*/

    const safe = (val) => (val === null || val === undefined ? "" : val);

    const tableBody = data.details.product_details
      .filter((item) => parseFloat(item.quantity || 0) > 0)
      .map((item) => {
        const promoDisc = parseFloat(item.promo_disc_amount || 0);
        const itemDisc = parseFloat(item.item_discount || 0);
        const rawDiscountType =
          item.productWiseDiscountType || item.discount_type || "amount";
        const discountType =
          String(rawDiscountType).toLowerCase() === "percentage"
            ? "percentage"
            : "amount";
        let discountDisplay = "";
        if (promoDisc > 0) {
          discountDisplay = `£ ${promoDisc.toFixed(2)}`;
        } else if (itemDisc > 0) {
          if (discountType === "percentage") {
            discountDisplay = `${parseFloat(item.discount || 0).toFixed(0)}%`;
          } else {
            discountDisplay = `£ ${itemDisc.toFixed(2)}`;
          }
        }
        const productLabel =
          `${safe(item.product_code)} - ${safe(item.product_name)}` +
          (item.size ? ` - ${safe(item.size)}` : "") +
          (item.promo_product ? ` ${safe(item.promo_product)}` : "") +
          (item.free_product ? ` ${safe(item.free_product)}` : "");
        const qtyDisplay =
          item.quantity !== null &&
          item.quantity !== undefined &&
          item.quantity !== ""
            ? parseFloat(item.quantity)
            : "";
        return [
          productLabel,
          safe(item.order_type),
          qtyDisplay,
          `£ ${parseFloat(item.unit_price || 0).toFixed(2)}`,
          discountDisplay,
          `£ ${parseFloat(item.item_tax || 0).toFixed(2)}`,
          `£ ${parseFloat(item.subtotal || 0).toFixed(2)}`,
        ];
      });

    tableBody.push([
      { content: "Item Total:", colSpan: 6, styles: { halign: "right" } },
      { content: `£ ${itemTotal.toFixed(2)}` },
    ]);

    tableBody.push([
      {
        content: `NON VAT Goods - £ ${totalzeroGoods.toFixed(2)}  | VAT Goods - £ ${totalstd.toFixed(2)}`,
        colSpan: 5,
        styles: { halign: "left" },
      },
      { content: "Total Vat:", styles: { halign: "right" } },
      { content: `£ ${totalVAT.toFixed(2)}` },
    ]);

    tableBody.push([
      {
        content: `Order Discount(${over_all_discount}%)`,
        colSpan: 6,
        styles: { halign: "right", fontStyle: "bold" },
      },
      { content: `£ ${over_all_amount.toFixed(2)}` },
    ]);

    if (bundleDiscounts.length > 0) {
      tableBody.push([
        {
          content: "Promo Discount",
          colSpan: 6,
          styles: { halign: "right", fontStyle: "bold" },
        },
        { content: `£ ${promoDiscount.toFixed(2)}` },
      ]);
      tableBody.push([
        {
          content: "Promo VAT",
          colSpan: 6,
          styles: { halign: "right", fontStyle: "bold" },
        },
        { content: `£ ${promoVat.toFixed(2)}` },
      ]);
    }

    tableBody.push([
      {
        content: `Box : ${box_qty} PCs : ${piece_qty} `,
        colSpan: 5,
        styles: { halign: "left", fontSize: 8, fontStyle: "bold" },
      },
      {
        content: "Total Amount",
        styles: { halign: "right", fontSize: 8, fontStyle: "bold" },
      },
      { content: `£ ${totalAmount.toFixed(2)}` },
    ]);

    

    doc.autoTable({
      startY: y,
      head: [tableColumns.map(col => col.title)],
      body: tableBody,
      theme: 'grid',
      headStyles: {
        fillColor: '#f8f9fa',
        textColor: '#404040',
        fontSize: 8,  
        valign: 'middle', 
        lineWidth: 0.3,
        halign: 'center', 
        lineWidth: 0.3,
        lineColor: [0, 0, 0] 
      },
      bodyStyles: {
        fontSize: 8,  
        valign: 'middle',
        lineWidth: 0.3,
        lineColor: [0, 0, 0] 
      },
  margin: { top: 0, left: margin, right: margin },

  columnStyles: {
    0: { cellWidth: productWidth, fontSize: 8, fontStyle: 'bold' },
    1: { cellWidth: orderTypeWidth, fontSize: 8, fontStyle: 'bold' },
    2: { cellWidth: qtyWidth, fontSize: 8, fontStyle: 'bold' },
    3: { cellWidth: unitPriceWidth, fontSize: 8, fontStyle: 'bold' },
    4: { cellWidth: discountWidth, fontSize: 8, fontStyle: 'bold' },
    5: { cellWidth: vatWidth, fontSize: 8, fontStyle: 'bold' },
    6: { cellWidth: netAmountWidth, fontSize: 8, fontStyle: 'bold' },
    1: { halign: 'center' },
    2: { halign: 'center' },
    3: { halign: 'right' },
    4: { halign: 'center' },
    5: { halign: 'right' },
    6: { halign: 'right' },
  },
  
});


    y = doc.autoTable.previous.finalY + 5; // Y position after table

    const addFooterSection = (footerSection) => {
      footerSection.forEach((section, index) => {
        const colStartX = margin + (index % 4) * sectionWidth;

        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(item.bold ? 'helvetica' : 'helvetica', item.bold ? 'bold' : 'normal');
          doc.text(item.text, colStartX, y + i * 5);
        });

        if (index % 4 === 3) {
          y += 20; // Move down after every 4 sections
        }
      });
      y += 35; // Add space after each footer section
    };

    const addFooterWithSpaceCheck = (footerSection) => {
      const remainingSpace = pageHeight - y - margin; // Remaining space on the page
      const requiredSpace = footerSection.length * 5 + 20; // Space needed

      if (remainingSpace < requiredSpace) {
        doc.addPage(); // Add a new page if not enough space
        y = margin; // Reset Y position for new page
      }

      addFooterSection(footerSection);
    };

    const footerSections2 = [
      [
        { text: 'Good Received & Checked By : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ No of Boxes Received : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _', size: 8, bold: false },
        { text: '', size: 8, bold: false },
        { text: 'Amount Paid : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ Cash / Cheque Collected By : _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _', size: 8, bold: false },
        { text: 'Terms -', size: 8, bold: false },
        { text: `1 - Once delivery is received ${shopDetails.shop_name} is not responsible for any damage or loss `, size: 8, bold: false },
        ]
      ];
    addFooterWithSpaceCheck(footerSections2);
     const footerSections3 = [
  [
    { text: `Note: ${orderDetails.staff_note}`, size: 8, bold: true },
  ]
];

    addFooterWithSpaceCheck(footerSections3);
 if (Array.isArray(deliveryDetails) && deliveryDetails.length > 0) {
    // Add "Goods Collected By" and "Signature" box at the bottom
    const boxMarginTop = 5;
const boxHeight = 20;
const boxWidth = pageWidth - 2 * margin;
let boxY = y + boxMarginTop;

// Ensure box fits on page, else add new page
if (boxY + boxHeight > pageHeight - margin) {
  doc.addPage();
  boxY = margin + boxMarginTop;
}

// Draw the box
doc.setLineWidth(0.2);
doc.rect(margin, boxY, boxWidth, boxHeight);

// Add the labels inside the box
doc.setFontSize(10);
doc.setFont('helvetica', 'bold');
let collectedByText = 'Goods Collected By:';
let signatureText = 'Signature:';

// If deliveryDetails is present, use dynamic values

  const recipient = deliveryDetails[0];
  if (recipient.received_by) {
    collectedByText = `Goods Collected By: ${recipient.received_by}`;
  }


doc.text(collectedByText, margin + 5, boxY + 15);
doc.text(signatureText, margin + boxWidth / 2 + 5, boxY + 15);

// Remove lines for writing/signature
// doc.setLineWidth(0.2);
// doc.line(margin + 40, boxY + 15, margin + boxWidth / 2 - 10, boxY + 15); // Line for "Goods Collected By"
 doc.line(margin + boxWidth / 2 + 25, boxY + 15, margin + boxWidth - 10, boxY + 15); // Line for "Signature"

// If deliveryDetails has a signature, add it above the signature label
if (Array.isArray(deliveryDetails) && deliveryDetails.length > 0) {
  const recipient = deliveryDetails[0];
  if (recipient.recipient_signature) {
    const sigWidth = 15; // smaller width
    const sigHeight = 10; // smaller height
    const sigAreaStart = margin + boxWidth / 2 + 15;
    const sigAreaEnd = margin + boxWidth - 10;
    const sigX = sigAreaStart + ((sigAreaEnd - sigAreaStart) - sigWidth) / 2;
    const sigY = boxY + 4;
    doc.addImage(recipient.recipient_signature, 'PNG', sigX, sigY, sigWidth, sigHeight);
  }
}

y = boxY + boxHeight + 5; // Update y for any further content
}

    const filename = generateUniqueFilename('Invoice', 'pdf');
    //doc.save(filename);

    doc.autoPrint();
    window.open(doc.output('bloburl'));

  } catch (error) {
    console.error('Error generating PDF:', error);
  }
};

export default generateOrderSummaryPDF;
